import React, { useEffect } from "react";
import Header from "./components/HeaderComponent/Header";
import Login from "./components/LoginComponent/Login";
import Menu from "./components/MenuComponent/Menu";
import "../src/assests/css/master.css";
import Claimdetail from "./components/ClaimComponent/Claimdetail";
import Taload from "./components/ClaimComponent/Taload";
import Taloadrequest from "./components/ClaimComponent/Taloadrequest";
import { Route, Routes, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/Errorboundry/Errorboundry";
import ClientList from "./components/Clients";
import AddNewClient from "./components/Clients/AddNewClient";
import Profile from "./components/Profile";
import DTHRecharge from "./components/DthRecharge";
import OTTRecharge from "./components/OttRecharge";
import MobileRecharge from "./components/MobileRecharge";
import FooterComponent from "./components/FooterComponent/FooterComponent";
import DMTService from "./components/DirectMoneyTransfer";
import AdminHome from "./components/Admin Home";
import BillPaymentDashboard from "./components/Dashboard/Billpayment";
import { toast, ToastContainer } from "react-toastify";
import VarificationScreen from "./components/Clients/VarificationScreen";
import ShopDetails from "./components/Clients/RetailerBussnessType";
import RetailerDocuments from "./components/Clients/RetailerDocuments";
import DmtRouting from "./components/ClientRouting/DmtRouting";
import MobileRechargeRouting from "./components/ClientRouting/MobileRechargeRouting";
import RechargeRouting from "./components/ClientRouting/VasRouting";
import BillPaymentRouting from "./components/ClientRouting/BillPayRouting";
import AccountHistory from "./components/AccountHistory";
import DmtSupplierConfiguration from "./components/SupplierConfiguration/Dmt/DmtSupplierConfiguration";
import DmtSuuplierConfigList from "./components/SupplierConfiguration/Dmt/DmtSupplierConfigList";
import DmtSupplierConfigDetails from "./components/SupplierConfiguration/Dmt/DmtSupplierConfigDetails";
import ProductList from "./components/Products";
import ProductGroup from "./components/Products/ProductGroup";
import CreateproductGroup from "./components/Products/createproductGroup/CreateproductGroup";
import "bootstrap-icons/font/bootstrap-icons.css";
import AEPSService from "./components/AEPS";
import Payoutservice from "./components/Payout";
import Escrow from "./components/Escrow";
import RefundStatus from "./components/RefundStatus";
import { useDispatch, useSelector } from "react-redux";
import { selectRetailerRequesterId } from "./redux/RequesterId/action";
import TicketList from "./components/Ticket/Ticket";
import TicketDeatails from "./components/Ticket/TicketDeatails";

const App = () => {
  const PublicRoute = ({ children }) => {
    let token = sessionStorage.getItem("token");

    return token ? (
      <Navigate to="/bill-payment" replace />
    ) : (
      <ErrorBoundary>{children}</ErrorBoundary>
    );
  };

  const PrivateRoute = ({ children }) => {
    let token = sessionStorage.getItem("token");

    return token ? (
      <React.Fragment>
        <Header />
        <Menu />
        <ErrorBoundary>{children}</ErrorBoundary>
        <ToastContainer />
      </React.Fragment>
    ) : (
      <Navigate to="/" replace />
    );
  };
  return (
    <React.Fragment>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/bill-payment"
          element={
            <PrivateRoute>
              <BillPaymentDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/taLoad"
          element={
            <PrivateRoute>
              <Taload />
            </PrivateRoute>
          }
        />

        <Route
          path="/claim-detail"
          element={
            <PrivateRoute>
              <Claimdetail />
            </PrivateRoute>
          }
        />

        <Route
          path="/ta-load-request"
          element={
            <PrivateRoute>
              <Taloadrequest />
            </PrivateRoute>
          }
        />
        <Route
          path="/clients"
          element={
            <PrivateRoute>
              <ClientList />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-new-client"
          element={
            <PrivateRoute>
              <AddNewClient />
            </PrivateRoute>
          }
        />

        <Route
          path="/otp-varification"
          element={
            <PrivateRoute>
              <VarificationScreen />
            </PrivateRoute>
          }
        />

        <Route
          path="/business-details"
          element={
            <PrivateRoute>
              <ShopDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/retailer-document"
          element={
            <PrivateRoute>
              <RetailerDocuments />
            </PrivateRoute>
          }
        />

        <Route
          path="/profile/:id"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/dth-recharge"
          element={
            <PrivateRoute>
              <DTHRecharge />
            </PrivateRoute>
          }
        />
        <Route
          path="/ott-recharge"
          element={
            <PrivateRoute>
              <OTTRecharge />
            </PrivateRoute>
          }
        />
        <Route
          path="/mobile-recharge"
          element={
            <PrivateRoute>
              <MobileRecharge />
            </PrivateRoute>
          }
        />
        <Route
          path="/money-transfer"
          element={
            <PrivateRoute>
              <DMTService />
            </PrivateRoute>
          }
        />
        <Route
          path="/retailer-list"
          element={
            <PrivateRoute>
              <AdminHome />
            </PrivateRoute>
          }
        />
        <Route
          path="/dmt-routing/:id"
          element={
            <PrivateRoute>
              <DmtRouting />
            </PrivateRoute>
          }
        />
        <Route
          path="/mobile-recharge-routing/:id"
          element={
            <PrivateRoute>
              <MobileRechargeRouting />
            </PrivateRoute>
          }
        />

        <Route
          path="/recharge-routing/:id"
          element={
            <PrivateRoute>
              <RechargeRouting />
            </PrivateRoute>
          }
        />

        <Route
          path="/billpayment-routing/:id"
          element={
            <PrivateRoute>
              <BillPaymentRouting />
            </PrivateRoute>
          }
        />
        <Route
          path="/account-history/:id"
          element={
            <PrivateRoute>
              <AccountHistory />
            </PrivateRoute>
          }
        />
        <Route
          path="/dmt-supplier-config"
          element={
            <PrivateRoute>
              <DmtSupplierConfiguration />
            </PrivateRoute>
          }
        />
        <Route
          path="/dmt-supplier-config-list"
          element={
            <PrivateRoute>
              <DmtSuuplierConfigList />
            </PrivateRoute>
          }
        />
        <Route
          path="/dmt-supplier-config-details"
          element={
            <PrivateRoute>
              <DmtSupplierConfigDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/product-list"
          element={
            <PrivateRoute>
              <ProductList />
            </PrivateRoute>
          }
        />
        <Route
          path="/product-group-list"
          element={
            <PrivateRoute>
              <ProductGroup />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-new-product-group"
          element={
            <PrivateRoute>
              <CreateproductGroup />
            </PrivateRoute>
          }
        />
        <Route
          path="/aeps-dashboard"
          element={
            <PrivateRoute>
              <AEPSService />
            </PrivateRoute>
          }
        />
        <Route
          path="/escrow"
          element={
            <PrivateRoute>
              <Escrow />
            </PrivateRoute>
          }
        />
        <Route
          path="/refund-status"
          element={
            <PrivateRoute>
              <RefundStatus />
            </PrivateRoute>
          }
        />
        <Route
          path="/payout-dashboard"
          element={
            <PrivateRoute>
              <Payoutservice />
            </PrivateRoute>
          }
        />
        <Route
          path="/ticket-list"
          element={
            <PrivateRoute>
              <TicketList />
            </PrivateRoute>
          }
        />

        <Route
          path="/ticket-details"
          element={
            <PrivateRoute>
              <TicketDeatails />
            </PrivateRoute>
          }
        />
      </Routes>
      <FooterComponent />
    </React.Fragment>
  );
};

export default App;
